import { all, fork } from "redux-saga/effects";

import { saga as sharedSaga } from "../shared/store";
import { saga as authSaga } from "../containers/Auth/store";
import { saga as casesSaga } from "../containers/Cases/store";
import { saga as usersSaga } from "../containers/Users/store";
import { saga as evaluationSaga } from "../containers/Evaluation/store";

const allSagas = [sharedSaga, authSaga, casesSaga, usersSaga, evaluationSaga];

export default function* appSagas() {
  yield all(allSagas.map(fork));
}
